import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Switch,
  Button,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const Products = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [reOrderLevel, setReOrderLevel] = useState(10);
  const [sellDigitalProduct, setSellDigitalProduct] = useState(false);
  const [showBrand, setShowBrand] = useState(false);

  useEffect(() => {
    const p = settings.custom?.products;
    if (!p) return;
    if (p.reOrderLevel !== undefined) setReOrderLevel(p.reOrderLevel);
    if (p.sellDigitalProduct !== undefined) setSellDigitalProduct(p.sellDigitalProduct);
    if (p.showBrand !== undefined) setShowBrand(p.showBrand);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleReOrderLevelChange = (event) => {
    setReOrderLevel(event.target.value);
  };

  const handleSellDigitalProductChange = (event) => {
    setSellDigitalProduct(event.target.checked);
  };

  const handleShowBrandChange = (event) => {
    setShowBrand(event.target.checked);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { products: { reOrderLevel, sellDigitalProduct, showBrand } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Typography variant="h6" color="text.primary" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <ShoppingCartIcon sx={{ mr: 1, color: 'primary.main' }} />
          Product Setup
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Re-Order Level"
              type="number"
              value={reOrderLevel}
              onChange={handleReOrderLevelChange}
              InputProps={{ inputProps: { min: 0 }, endAdornment: <InfoIcon color="primary" /> }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body1" color="text.primary">
              Sell Digital Product
              <InfoIcon color="primary" />
            </Typography>
            <Switch checked={sellDigitalProduct} onChange={handleSellDigitalProductChange} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body1" color="text.primary">
              Show Brand
              <InfoIcon color="primary" />
            </Typography>
            <Switch checked={showBrand} onChange={handleShowBrandChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <Button variant="contained" color="primary" onClick={handleSave} disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Box>

        <SaveSnackbar snack={snack} onClose={closeSnack} />
      </CardContent>
    </Card>
  );
};

export default Products;
